import { FormProvider } from "react-hook-form";
import { Combobox, ComboboxHeader } from "@/components/ui/form";
import { Button } from "@/components/ui/button";
import { MagnifyingGlassIcon } from "@heroicons/react/24/outline";

export const SearchForm = ({
    methods,
    onSubmit,
    serviceTypes,
    professions,
    hideCheck = false,
}) => {
    return (
        <FormProvider {...methods}>
            <form
                onSubmit={methods.handleSubmit(onSubmit)}
                className="flex w-full items-center"
            >
                <div className="relative flex-1">
                    <Combobox
                        type="text"
                        name="serviceSearch"
                        label="CARE OR SPECIALTY"
                        placeholder="Physiotherapy, GP, Therapist"
                        className="pr-26 text-sm"
                        icon={MagnifyingGlassIcon}
                        floatingLabel={true}
                        onChange={(value) => {
                            if (!value) return;
                            methods.handleSubmit(onSubmit)();
                        }}
                        onFocus={(e) => {
                            e.target.select();
                            // opening is handled by Headless UI
                        }}
                        hideCheck={hideCheck}
                        variant="white"
                        multiple
                    >
                        <ComboboxHeader className="text-[0.6875rem]/6 font-medium tracking-widest uppercase">
                            Professions
                        </ComboboxHeader>

                        {professions?.map((d) => (
                            <option
                                key={`p-${d.typeGuid}`}
                                value={`p-${d.typeGuid}`}
                                className="block rounded-lg px-3 py-2 transition hover:bg-black/5 hover:text-darkgreen-300"
                            >
                                {d.title}
                            </option>
                        ))}

                        <ComboboxHeader className="text-[0.6875rem]/6 font-medium tracking-widest uppercase">
                            Services
                        </ComboboxHeader>

                        {serviceTypes?.map((d) => (
                            <option
                                key={`s-${d.typeGuid}`}
                                value={`s-${d.typeGuid}`}
                                className="block rounded-lg px-3 py-2 transition hover:bg-black/5 hover:text-darkgreen-300"
                            >
                                {d.title}
                            </option>
                        ))}
                    </Combobox>
                    <Button
                        variant="primary"
                        className="absolute end-3 top-2.5"
                    >
                        Search
                    </Button>
                </div>
            </form>
        </FormProvider>
    );
};
